import type { Activity } from "@/types";

/** Shown in the customer catalog: staff-active and seller-visible. */
export function isActivityListed(
  activity: Pick<Activity, "is_active" | "is_visible">,
): boolean {
  return activity.is_active && activity.is_visible;
}
